
export class Live{

  start:number;
  end:number;
  beforeStart:{
    title:string,
    description:string,
    backgroundImage:string,
  };
  afterEnd:{
    title:string,
    description:string,
    backgroundImage:string,
  };

  constructor(object = null){
    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.start){
      this.start = object.start;
    }
    if(object.end){
      this.end = object.end;
    }
    if(object.beforeStart){
      this.beforeStart = {
        title: object.beforeStart.title,
        description: object.beforeStart.description,
        backgroundImage: object.beforeStart.backgroundImage,
      };
    }
    if(object.afterEnd){
      this.afterEnd = {
        title: object.afterEnd.title,
        description: object.afterEnd.description,
        backgroundImage: object.afterEnd.backgroundImage,
      };
    }
  }

  getStartDate(){
    return new Date(this.start * 1000);
  }
}
  